import { asyncRequest, registerComponent, loading } from "helpers";
import { WYATTElement } from "wyatt";

const BASE_URL = `${WYATT.routes.root}apps/syatt/offers`;

registerComponent(
  "other-buying-options",
  class OtherBuyingOptions extends WYATTElement {
    get templates() {
      return {
        container: document.getElementById(
          "templates-other-buying-options-container"
        ).content,
        item: document.getElementById("templates-other-buying-options-item")
          .content,
      };
    }

    get endpoint() {
      const searchParams = new URLSearchParams({
        isbns: [this.config.isbn],
      });

      return `${BASE_URL}?${searchParams.toString()}`;
    }

    formatPrice(price, currency = "USD") {
      return new Intl.NumberFormat(navigator.language || "en-US", {
        style: "currency",
        currency,
      }).format(price);
    }

    formatCondition(rentalDays, condition) {
      if (rentalDays) {
        const numberOfRentalDays = rentalDays.match(/\d+/)[0];
        return `${condition} - ${numberOfRentalDays} ${WYATT.t.otherBuyingOptions.dayRental}`;
      }

      return `${WYATT.t.otherBuyingOptions.condition}: ${condition}`;
    }

    buildItems(offers = []) {
      if (offers.length === 0) {
        // eslint-disable-next-line no-console
        console.warn("No offers found for ISBN", this.isbn);
        return document.createElement("div");
      }

      return offers.map((offer) => {
        const itemElement = this.templates.item.cloneNode(true);

        itemElement.querySelector("[data-item-merchant]").textContent =
          offer.merchant;

        itemElement.querySelector("[data-item-condition]").textContent =
          this.formatCondition(offer.rentalDays, offer.condition);

        itemElement.querySelector("[data-item-description]").textContent =
          offer.description;

        if (offer.description) {
          const readMoreElement = itemElement.querySelector("[data-read-more]");

          readMoreElement.classList.remove("hidden");

          readMoreElement.addEventListener("click", (event) => {
            event.preventDefault();

            readMoreElement.classList.add("hidden");

            event.target.parentElement
              .querySelector("[data-item-description]")
              .classList.toggle("hidden");
          });
        }

        itemElement.querySelector("[data-item-base-price]").textContent =
          this.formatPrice(offer.price, offer.currency);

        itemElement.querySelector("[data-item-shipping-price]").textContent =
          offer.shipping === 0
            ? WYATT.t.otherBuyingOptions.free
            : this.formatPrice(offer.shipping, offer.currency);

        // Fixes ampersand encoding in link
        const href = offer.link.replace(/&amp;/g, "&");
        itemElement.querySelector("[data-item-link]").href = href;

        return itemElement;
      });
    }

    buildContainer(item) {
      if (!item) {
        // eslint-disable-next-line no-console
        console.warn("No item found for ISBN", this.isbn);
        return document.createElement("div");
      }

      const containerElement = this.templates.container.cloneNode(true);

      containerElement
        .querySelector("[data-list]")
        .append(...this.buildItems(item.offers));

      return containerElement;
    }

    buildUI(response) {
      const item = response?.items?.[0];
      this.appendChild(this.buildContainer(item));
    }

    addLoadingIndicator() {
      this.classList.add("other-buying-options--loading");
      loading.add(this);
    }

    removeLoadingIndicator() {
      this.classList.remove("other-buying-options--loading");
      loading.remove(this);
    }

    async connectedCallback() {
      this.addLoadingIndicator();

      try {
        const response = await asyncRequest(
          this.endpoint,
          {},
          { responseFormat: "json" }
        );

        this.removeLoadingIndicator();
        this.buildUI(response);
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error loading other buying options:", error);
        this.removeLoadingIndicator();
      }
    }
  }
);
